import { render } from "./BuyGiftInfo.vue?vue&type=template&id=6e99eff0&scoped=true"
import script from "./BuyGiftInfo.vue?vue&type=script&lang=js"
export * from "./BuyGiftInfo.vue?vue&type=script&lang=js"

import "./BuyGiftInfo.vue?vue&type=style&index=0&id=6e99eff0&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e99eff0"]])

export default __exports__